import React, { Component } from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import ClipboardTouchable from '../clipboard_touchable';
import OPComponent from '../op_component';
import ArrowRight from '../display/arrow_right';

export default class ArrowButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { label, value, disabled, noTopBorder, textStyle } = this.props;

    const extraTextStyles = [textStyle || null, disabled ? styles.disabledButtonText : null];
    return (
      <ClipboardTouchable
        style={[styles.arrowButton, noTopBorder ? { borderTopWidth: 0 } : null]}
        onPress={this.props.onPress}
        disabled={!!disabled}
        text={value}
      >
        <View style={styles.container}>
          {!!label && <Text style={[styles.labelText].concat(extraTextStyles)}>{label}</Text>}
          <Text style={[styles.valueText].concat(extraTextStyles)}>{value}</Text>
        </View>
        <ArrowRight disabled={!!disabled} />
      </ClipboardTouchable>
    );
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  arrowButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
    paddingHorizontal: 25,
    paddingVertical: 15,
  },
  labelText: {
    ...FONT.bold,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.text,
  },
  valueText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.text,
  },
  disabledButtonText: {
    color: COLOR.textDisabled,
  },
});
